import { getOwaRouterRoutesForUnifiedSearch } from './getOwaRouterRoutesForUnifiedSearch';
import type { RegisterRouteFunction } from 'owa-router';

/**
 * Registers all unified search routes for owa-router to support refreshes.
 * @param routeHandlerCallback Callback called on landing directly on any search route
 * @param routeCleanupCallback Callback called on navigating away from the base search route
 */
export const registerSearchRoutes = (
    registerRoute: RegisterRouteFunction,
    routeHandlerCallback?: () => void,
    routeCleanupCallback?: () => void
) => {
    const routeCleanup = (
        oldRoute: string[],
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
         * See aka.ms/mini-lint-errors
         *	> Unexpected any. Specify a different type. */
        oldParams: any,
        newRoute: string[],
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any --
         * undefined
         * See aka.ms/mini-lint-errors
         *	> 'newParams' is defined but never used.
         *	> Unexpected any. Specify a different type. */
        newParams: any
    ) => {
        if (!newRoute.includes('search')) {
            // only call cleanup callback if we're exiting the search
            // rest everything should be managed by internal routing
            routeCleanupCallback?.();
        }
        return false;
    };

    getOwaRouterRoutesForUnifiedSearch().forEach(route => {
        registerRoute(route, routeHandlerCallback, routeCleanup);
    });
};
